import NiceModal from '@ebay/nice-modal-react'
import { Container, Group, Space, Stack } from '@mantine/core'

import { ModalShell, useModalControls } from '#components/Modals'
import { useMst } from '#state'

import { modalShortcuts } from './helpers'
import { ShortcutTable } from './Table'

import styles from './Shortcuts.module.scss'

const NAV_COL_WIDTH = 450
const EL_COL_WIDTH = 260

const Shortcuts = () => {
  const controls = useModalControls()
  const mst = useMst()
  const platform = mst.view.isDebugEnabled('windows') ? 'win' : undefined
  const elementShortcuts =
    mst.currentScript?.observableEditor?.elementPickerKeys ?? []

  const shortcuts = modalShortcuts(platform)
  const navRows = Object.entries(shortcuts.navigation)
  const formattingRows = Object.entries(shortcuts.formatting)

  const modalWidth = elementShortcuts.length
    ? NAV_COL_WIDTH + EL_COL_WIDTH
    : NAV_COL_WIDTH

  return (
    <ModalShell
      title="Keyboard Shortcuts"
      size={modalWidth}
      opened={controls.opened}
      onClose={controls.onClose}
    >
      <Group gap="xl" align="flex-start" grow>
        <Container className={styles.shortcuts_container} size={NAV_COL_WIDTH}>
          <Stack gap={5}>
            <ShortcutTable title="Navigation" rows={navRows} />
            <Space h="md" />
            <ShortcutTable title="Formatting" rows={formattingRows} />
          </Stack>
        </Container>
        {elementShortcuts.length > 0 && (
          <Container className={styles.shortcuts_container} size={EL_COL_WIDTH}>
            <Stack gap={5}>
              <ShortcutTable
                title="Elements"
                rows={elementShortcuts.map(({ displayName, shortcut }) => [
                  displayName,
                  shortcut,
                ])}
              />
            </Stack>
          </Container>
        )}
      </Group>
    </ModalShell>
  )
}

export const ShortcutsModal = NiceModal.create(Shortcuts)

// See (../readme.md)
// oxlint-disable-next-line react/only-export-components
export const showShortcutsModal = () => NiceModal.show(ShortcutsModal)
